import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/interactive-calendar-schedule-management/components/CalendarInteractive.tsx");
